<template>
    <div>
        <breadcrumb></breadcrumb>
        <div class="h-formBox">
            <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
            <el-form-item label="分类">
                <el-select v-model="formInline.classification" placeholder="" style="width:1.5rem">
                <el-option label="自产" value="自产"></el-option>
                <el-option label="OEM" value="OEM"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单类型">
                <el-select v-model="formInline.orderType" placeholder="" style="width:1.5rem">
                <el-option label="标准订单" value="标准订单"></el-option>
                <el-option label="项目订单" value="项目订单"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="物料编码">
                <el-select v-model="formInline.codeNum" placeholder="" style="width:1.5rem">
                <el-option label="XM34832742" value="XM34832742"></el-option>
                <el-option label="XM34832742" value="XM34832742"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="产品型号">
                <el-select v-model="formInline.productModel" placeholder="" style="width:1.5rem">
                <el-option label="SI9343290" value="SI9343290"></el-option>
                <el-option label="SI9343290" value="SI9343290"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="h-formBtnOut">
                <el-button class="h-btn h-formBtn">检索</el-button>
            </el-form-item>
            </el-form>
        </div>
        <el-table
			 ref="multipleTable"
			 @selection-change="handleSelectionChange"
			:data="tableData2"
			stripe
			border
			style="width: 100%"
			>
			<el-table-column
			  type="selection"
			  width="55"
			  label="全选"
			  >
			</el-table-column>
			<el-table-column
			  type="index"
              width="55"
			  label="序号">
			</el-table-column>
			<el-table-column
			  prop="classification"
			  label="分类"
              width="80">
			</el-table-column>
			<el-table-column
			  prop="orderType"
			  label="订单类型"
			  :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
			  prop="cname"
			  label="产品名称"
			  :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
			  prop="codeNum"
			  label="物料编码"
			  :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
			  prop="productModel"
			  label="产品型号"
			  :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
			  prop="orderNum"
			  label="订单数量"
              width="100">
			</el-table-column>
            <el-table-column
			  prop="basePrice"
			  label="基准价">
			</el-table-column>
            <el-table-column
			  prop="transaction"
			  label="成交价">
			</el-table-column>
            <el-table-column
			  prop="total"
			  label="总价">
			</el-table-column>
			<el-table-column
			  label="操作"
			  >
			  <template slot-scope="scope">
				<div style="display:flex">
                    <router-link :to="{name:'dingd/material/orderDetail'}">
                        <el-button
                        type="text"
                        size="small"
                        class="h-tableLink">
                                查看详情
                        </el-button>
                    </router-link>
                    <el-button
                    type="text"
                    size="small"
                    class="h-tableLink">
                            盈利测算
                    </el-button>
                </div>
				<!-- <div class="l-operationBox">
					<router-link :to="{name:'dingd/material/orderDetail'}">
						<span class="l-operationlist br-operation-look" title="查看详情"></span>
					</router-link>
					<span class="l-operationlist br-operation-ylcs" title="盈利测算"></span>
				</div> -->
			  </template>
			</el-table-column>
		  </el-table>
          <div style="display:flex;justify-content: space-between;margin-top:20px">
              <el-button type="primary">导出
                <img src="../../../assets/images/pimg/daochu.png" alt="" style="width:20px;">
              </el-button>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage4"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="100"
                layout="total, sizes, prev, pager, next, jumper"
                :total="400"
                >
              </el-pagination>
          </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            formInline: {
                classification:'',
                orderType:'',
                codeNum:'',
                productModel:''
            },
            multipleSelection: [],
            tableData2: [{
                classification: '自产',
                orderType:'标准订单',
                cname: 'xxx产品',
                codeNum: 'XM34832742',
                productModel: 'SI9343290',
                orderNum: 32,
                basePrice: "5,000,000",
                transaction: "5,000,000",
                total: "5,000,000"
            },
            {
                classification: '自产',
                orderType:'标准订单',
                cname: 'xxx产品',
                codeNum: 'XM34832742',
                productModel: 'SI9343290',
                orderNum: 32,
                basePrice: "5,000,000",
                transaction: "5,000,000",
                total: "5,000,000"
            },
            {
                classification: '自产',
                orderType:'标准订单',
                cname: 'xxx产品',
                codeNum: 'XM34832742',
                productModel: 'SI9343290',
                orderNum: 32,
                basePrice: "5,000,000",
                transaction: "5,000,000",
                total: "5,000,000"
            },
            {
                classification: '自产',
                orderType:'标准订单',
                cname: 'xxx产品',
                codeNum: 'XM34832742',
                productModel: 'SI9343290',
                orderNum: 32,
                basePrice: "5,000,000",
                transaction: "5,000,000",
                total: "5,000,000"
            }],
            currentPage4: 4
        }
    },
    methods:{
		handleSelectionChange(val) {
			this.multipleSelection = val;
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
        }
	}
}
</script>
<style scoped>
.h-formBox{
    width: 100%;
    padding: 20px;
    background: #fff;
    margin-bottom: 20px!important;
    line-height: 52px;
}
</style>
